import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  NEW_FIELD_BUTTON: `${cleanedFilename(__filename)}-new-field-button`,
  FIELDS_LIST: `${cleanedFilename(__filename)}-fields-list`,
};
